const fetchExcelDownload = async (id,parentid,fileName) => {
    const PUBLIC_URL = process.env.VUE_APP_API_BASE_URL;
    const BASE_URL = PUBLIC_URL + '/tenant';
    const TENANT = 'tenant';
    const ACCESS_TOKEN = 'access_token';

    const payload = {};
    payload.parentid = parentid;

    const response = await fetch(`${BASE_URL}/${window.localStorage.getItem(TENANT)}/api/upgpt_agent/document_agent/table_configuration/${id}/export/`, 
    {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload)
    });

    // response header
    const contentype = response.headers.get('Content-Type');

    let now = new Date()
    let yyyy = now.getFullYear()
    let MM = (now.getMonth()+1).toString().padStart(2,'0')
    let dd = now.getDate().toString().padStart(2,'0')
    let hh = now.getHours().toString().padStart(2,'0')
    let mm = now.getMinutes().toString().padStart(2,'0')
    let ss = now.getSeconds().toString().padStart(2,'0')
    let currentTime = `${yyyy}-${MM}-${dd} ${hh}${mm}${ss}`

    fileName = `${fileName} ${currentTime}`

    // 取得 ReadableStream (只有fetch的response有body)
    const reader = response.body.getReader();
    const chunks = [];

    let finish = false
    while (!finish) {
        const { done, value } = await reader.read();
        if (done) {
            finish = done
            break;
        }
        chunks.push(value);
    }

    // 合併 Uint8Array 並建立 Blob
    const blob = new Blob(chunks, { type: contentype });

    // 產生下載連結
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    // 清理
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}

export { fetchExcelDownload };